export enum InputType {
  Analog = 'analog',
  Formula = 'formula',
  PT = 'pt',
  Switch = 'switch',
  Channel = 'channel',
}

